module.exports = __webpack_public_path__ + "img/iiko-logo.8b4aaafe.png";